import styled from '@emotion/styled';

import { forMobile } from '@/design-system';

export const PipelineToggleRow = styled('label')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  color: theme.colors.white[80],
  cursor: 'pointer',
}));
export const FiltersShell = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  flexWrap: 'nowrap',

  [forMobile]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 8,
  },
});

export const FilterControl = styled('div')({
  flex: '0 0 240px',
  minWidth: 0,

  '&[data-filter-size="small"]': {
    flex: '0 0 136px',
  },

  [forMobile]: {
    flex: '0 0 auto',

    '&[data-filter-size="small"]': {
      flexBasis: 'auto',
    },
  },
});

export const FilterActiveOnlyControl = styled('div')({
  flex: '0 0 auto',

  [forMobile]: {
    width: '100%',
  },
});

export const FilterResetControl = styled('div')({
  flex: '0 0 auto',
  marginLeft: 'auto',

  [forMobile]: {
    width: '100%',
    marginLeft: 0,

    button: {
      width: '100%',
    },
  },
});
